import classNames from "classnames";
import React from "react";
import { styled } from "styled-components";

type Props = {
  children: React.ReactNode;
  $variant: string;
  className?: string;
  as?: keyof JSX.IntrinsicElements | React.ComponentType;
};

export const HeadingText = ({ as = "h1", className, ...props }: Props) => {
  return (
    <StyledHeadingText
      className={classNames(className || "pb-4")}
      {...props}
      as={as}
    />
  );
};

export const StyledHeadingText = styled.p<Props>`
  ${({ $variant, theme }) => {
    if ($variant === "heading01") {
      return theme.typography.headings.heading01;
    }
    if ($variant === "heading02") {
      return theme.typography.headings.heading02;
    }
    if ($variant === "heading03") {
      return theme.typography.headings.heading03;
    }
    if ($variant === "heading04") {
      return theme.typography.headings.heading04;
    }
    if ($variant === "heading05") {
      return theme.typography.headings.heading05;
    }

    console.warn(
      `HeadingText Component style warning: No style found for variant: ${$variant}`,
    );
  }}}
`;
